import React from "react";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";

const DepartmentListData = (props) => {
  return (
    <tr class="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-200">
      <td class="px-10 py-4">
        <input type="checkbox" />
      </td>
      <td scope="row" class="px-10 py-4 whitespace-nowrap">
        {props.requestdata.id}
      </td>
      <td class="px-10 py-4 text-blue-700 font-medium">
        {props.requestdata.department_name}
      </td>
      <td class="px-10 py-4 text-gray-800 font-medium">
        {props.requestdata.total_employees}
      </td>
      <td class="px-10 py-4">{props.requestdata.department_head}</td>
      <td class="px-10 py-4">
        <span className="py-1 px-2.5">
          <ToggleSwitch />
        </span>
      </td>
      <td class="px-10 py-4 flex justify-between items-center border-none">
        <img
          src="/images/edit-black-icon.svg"
          alt=""
          className="cursor-pointer"
        />
        <i className="ico-more text-gray-500 cursor-pointer"></i>
      </td>
    </tr>
  );
};

export default DepartmentListData;
